import React from 'react';
import { Icon } from '@iconify/react';

/**
 * props:
 * - icon
 * - title
 * - description
 * - actions
 * - children
 * - className
 */
export function PageCard({
    icon,
    title,
    description,
    actions,
    children,
    className = '',
}) {
    const hasHeader = icon || title || description || actions;

    return (
        <section className={`private-page-card ${className}`.trim()}>
            {hasHeader ? (
                <div className={`private-page-card-header${actions ? ' private-page-card-header--split' : ''}`.trim()}>
                    <div className="d-flex align-items-center gap-2">
                        {icon ? (
                            <span className="private-page-card-icon" aria-hidden="true">
                                <Icon icon={icon} width={20} height={20} />
                            </span>
                        ) : null}
                        <div>
                            {title ? <h2 className="private-page-card-title">{title}</h2> : null}
                            {description ? <p className="private-page-card-text">{description}</p> : null}
                        </div>
                    </div>
                    {actions ? <div className="private-page-card-toolbar">{actions}</div> : null}
                </div>
            ) : null}
            {children}
        </section>
    );
}

export default PageCard;